import { render } from "./rentalCard.vue?vue&type=template&id=6a053d86"
import script from "./rentalCard.vue?vue&type=script&lang=js"
export * from "./rentalCard.vue?vue&type=script&lang=js"

import "./rentalCard.vue?vue&type=style&index=0&id=6a053d86&lang=css"

import exportComponent from "/Users/matjeez/Matjez/Projects/websites/simonkr-feb24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__